export default __webpack_public_path__ + "static/media/profile.884162b1.jpg";